webpackJsonpUpdateBris([59],{

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ReviewForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(4);

var utils = _interopRequireWildcard(_utils);

var _api = __webpack_require__(144);

var Api = _interopRequireWildcard(_api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'ReviewForm';
var CLS = 'reviewForm';
var WG = '.' + CLS + '-';
var $loadingSpinner = $('.loading-spinner');
var CLS_ACTIVE = 'is-active';
var CLS_DISABLED = 'disabled';
var CLS_HIDE = 'd-none';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/reviewForm.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

var ReviewForm = exports.ReviewForm = function () {
	function ReviewForm($el) {
		_classCallCheck(this, ReviewForm);

		// $el is the widget node return by the loadReviewForm function
		this.$el = $el;
	}

	_createClass(ReviewForm, [{
		key: 'init',
		value: function init() {
			this.initFormValidationConstraints();
		}
	}, {
		key: 'initFormValidationConstraints',
		value: function initFormValidationConstraints() {
			var This = this;
			var $form = $(this.$el).find('form')[0];
			utils.formValidation($form, This);
		}
	}, {
		key: 'formSuccessCallback',
		value: function formSuccessCallback(form) {
			this.submitForm();
		}
	}, {
		key: 'submitForm',
		value: function submitForm() {
			var This = this;
			var $wg = $(this.$el);
			var $form = $wg.find('form');
			var $error = $wg.find(WG + 'error');
			var $success = $wg.find(WG + 'success');
			var $submitBtn = $wg.find(WG + 'submitBtn');

			$loadingSpinner.addClass(CLS_ACTIVE);
			This.reset();

			This.submitCall().then(function (resp) {
				if (resp.result === 'SUCCESS') {
					if (resp.message) {
						$success.addClass(CLS_ACTIVE).html(resp.message);
					} else {
						$wg.modal('hide');
					}

					$submitBtn.attr('disabled', true).addClass(CLS_HIDE);

					$form.find('input, textarea').prop('disabled', true);

					var writeBtn = document.querySelector(WG + 'writeBtn');
					if (writeBtn) {
						$(writeBtn).addClass('has-added').html('Pending moderation').removeAttr('data-toggle');
					}
				} else {
					$error.addClass(CLS_ACTIVE).html(resp.message);
				}

				$wg.animate({ scrollTop: 0 }, 500);

				$loadingSpinner.removeClass(CLS_ACTIVE);
			}).catch(function (error) {
				$error.addClass(CLS_ACTIVE).html(error);
				$loadingSpinner.removeClass(CLS_ACTIVE);

				$wg.animate({ scrollTop: 0 }, 500);
			});
		}
	}, {
		key: 'submitCall',
		value: function submitCall() {
			var $wg = $(this.$el);
			var $form = $wg.find('form');
			var endpoint = $wg.data('addReviewEndpoint');
			var fields = $form.serializeArray();
			var data = {};

			for (var key in fields) {
				// just putting an if here to remove lint errors
				if (fields) {
					var field = fields[key];
					data[field['name']] = field['value'] || '';
				}
			}

			data.productCode = $(document).find('[data-item-code]').data('itemCode') || '';

			if (!data.productCode || data.productCode == '') return Promise.reject('There was a problem submitting this review. Please try again later.');

			return Api.callApi(endpoint, data);
		}
	}, {
		key: 'reset',
		value: function reset() {
			var $wg = $(this.$el);
			var $form = $wg.find('form');
			var $error = $wg.find(WG + 'error');
			var $success = $wg.find(WG + 'success');
			var $submitBtn = $wg.find(WG + 'submitBtn');

			// $form.trigger('reset');
			$error.removeClass(CLS_ACTIVE).html('');
			$success.removeClass(CLS_ACTIVE).html('');
			$submitBtn.removeClass(CLS_HIDE).attr('disabled', false);
		}

		// Add more functions like on above here

	}]);

	return ReviewForm;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1754042353042.wg-review-form-chunk.js